module.exports = __webpack_public_path__ + "static/media/cinecruise-2.ba169817.jpg";